// extracted by mini-css-extract-plugin
export default {"detailIcon":"_3okd336_xRhLXqs0_g3","detailCollection":"hne6htx4uUhzRY3DyJQ3","issueCountLabel":"MAyoLNgrYmhSEVW2GqIu","count":"zenvNX15In34s5lOZFPG"};